<div class="author-info">
  <div class="cover-wrap">
    <on-ui-cover [cover]="cover()" [attr.data-test] = "'authorPhoto'"></on-ui-cover>
  </div>
  <a [routerLink]="profileUrl()" class="author-name">{{fullName()}}</a>
  <app-rating *ngIf="user?.stats?.reviews_rating" [stats]="user?.stats" [user]="user"></app-rating>
  <app-subscribe *ngIf="!withoutFollow" [user_id]="user?.id"></app-subscribe>
</div>
